import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Space,
} from "antd";

function TransactionModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
}) {
  return (
    <Modal
      title={"Add Transaction"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form layout="vertical" onFinish={onSave}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Type"
              name="is_credit"
              rules={[
                {
                  required: true,
                  message: "Please select type",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Credit</Radio>
                <Radio value={false}> Debit </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Amount" name={"amount"}>
              <InputNumber placeholder="Amount" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="User Email"
              name="user_email"
              rules={[
                {
                  required: true,
                  message: "Please input user email",
                },
              ]}
            >
              <Input placeholder="User Email" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Note"
              name="note"
              rules={[
                {
                  required: true,
                  message: "Please select Note",
                },
              ]}
            >
              <Select
                placeholder="Select Note"
                options={[
                  {
                    value: "ride charges deducted",
                    label: "Ride charges deducted",
                  },
                  {
                    value: "credits added to wallet by admin",
                    label: "Credits added to wallet by admin",
                  },
                  {
                    value: "credits added to wallet",
                    label: "Credits added to wallet",
                  },
                  {
                    value: "offer cashback added to wallet",
                    label: "Offer cashback added to wallet",
                  },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default TransactionModal;
